<template>
  <div>
    <div class="contract">
      <Header
        v-if="!checkCreatedDateNganluong(dataAppendix)"
        :groupService="dataContract.groupService"
      ></Header>
      <HeaderNL v-else :groupService="dataContract.groupService"></HeaderNL>
      <p class="txt-center fonsize-16 txt-tranf">CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</p>
      <p class="txt-center fonsize-16">Độc lập – Tự do – Hạnh phúc</p>
      <p class="txt-center fonsize-16">***</p>

      <p class="txt-tranf txt-center fonsize-20">
        <b>PHỤ LỤC BỔ SUNG DỊCH VỤ THANH TOÁN XUYÊN BIÊN GIỚI</b>
      </p>
      <p class="txt-center">
        (Số:
        <mark>{{ dataAppendix.code }}</mark>
        )
      </p>
      <p>Căn cứ:</p>
      <ol class="form-style2">
        <li>
          Hợp đồng hợp tác chấp nhận thanh toán số:
          <mark>{{
            dataAppendix?.isNganluongContract ? dataAppendix.codeOfContract : dataContract.code
          }}</mark>
          <p>
            ký ngày
            <mark v-if="dataAppendix?.isNganluongContract">
              {{ dataAppendix?.dateSignContract | formatDate }}</mark
            >
            <mark v-else>{{
              dataContract.effectiveFromDTO
                ? dataContract.effectiveFromDTO
                : dataContract.dateSign | formatDate
            }}</mark>
          </p>
        </li>
      </ol>
      <ol class="form-style2">
        <li>Nhu cầu và khả năng của hai Bên.</li>
      </ol>
      <p>
        Hôm nay, ngày
        <mark v-if="dataAppendix.dateSignAppendixDTO">{{
          dataAppendix.dateSignAppendixDTO | formatDate
        }}</mark>
        <mark v-else-if="dataAppendix.dateCreatedAppendixDTO">{{
          dataAppendix.dateCreatedAppendixDTO | formatDate
        }}</mark>
        <mark v-else-if="dataContract.effectiveFromDTO">{{
          dataContract.effectiveFromDTO | formatDate
        }}</mark>
        ,
        {{
          checkCreatedDateNganluong(dataAppendix)
            ? 'tại trụ sở Công ty Cổ phần cổng trung gian thanh toán Ngân Lượng, chúng tôi gồm có:'
            : 'tại trụ sở Công ty Cổ phần Công nghệ Vi Mô, chúng tôi gồm có:'
        }}
      </p>
      <p class="fonsize-16 txt-tranf flex">
        <b v-if="!checkCreatedDateNganluong(dataAppendix)"
          >BÊN A: CÔNG TY CỔ PHẦN CÔNG NGHỆ VI MÔ</b
        >
        <b v-else>BÊN A: CÔNG TY CỔ PHẦN CỔNG TRUNG GIAN THANH TOÁN NGÂN LƯỢNG</b>
      </p>
      <p>và</p>
      <p class="fonsize-16 txt-tranf flex">
        <span> <b>BÊN B:</b></span>
        <mark
          ><b>{{ dataAppendix.appendixQr && dataAppendix.appendixQr.merchantName }}</b></mark
        >
      </p>
      <p>Hai bên cùng thỏa thuận hợp tác và cam kết thực hiện những điều sau đây:</p>
      <p>&nbsp;</p>
      <ol class="form-style1">
        <li>
          <h1>Nội dung hợp tác</h1>
          <ul>
            <li>
              <b>Định nghĩa dịch vụ: Dịch vụ thanh toán xuyên biên giới</b> là dịch vụ thanh toán
              xuyên biên giới dành cho du khách Quốc tế tại Việt Nam bằng hình thức sử dụng mã
              QRCode trên điện thoại di động của du khách.
            </li>
            <li>
              <b>Nội dung hợp tác:</b>
              <ol class="form-style2">
                <li>
                  Bên B đồng ý sử dụng dịch vụ trên của Bên A cho phép Khách hàng của Bên B có thể
                  sử dụng Phương thức thanh toán QRCode quốc tế trên ứng dụng của Bên A để thanh
                  toán Hàng hóa/ dịch vụ cho Bên B.
                </li>
              </ol>
            </li>
          </ul>
        </li>
        <li>
          <h1>NGUYÊN TẮC CHẤP NHẬN THANH TOÁN BẰNG QRCODE XUYÊN BIÊN GIỚI</h1>
          <ul>
            <li>
              Bên B đảm bảo việc kinh doanh và cung cấp hàng hóa, dịch vụ trong phạm vi lãnh thổ
              Việt Nam, tuân thủ quy định của Pháp luật, thực hiện đầy đủ các thủ tục xin cấp
              phép/thông báo/đăng ký trong quá trình hoạt động kinh doanh với cơ quan nhà nước có
              thẩm quyền.
            </li>
            <li>
              Bên B cần đảm bảo thực hiện thanh toán qua phương thức thanh toán bằng QRCode xuyên
              biên giới của bên A tại trực tiếp điểm chấp nhận thanh toán, không thực hiện thanh
              toán Online từ xa.
            </li>
            <li>
              Bên B chỉ được thực hiện thanh toán qua Phương thức thanh toán bằng QRCode của Bên A
              đối với lĩnh vực kinh doanh đã đăng ký với Bên A theo phụ lục hợp đồng này. Nếu Bên B
              có bất kỳ sự thay đổi nào về lĩnh vực kinh doanh, phải có nghĩa vụ thông báo bằng văn
              bản hoặc các hình thức khác (được bên kia chấp nhận) với Bên A trước 15 (mười lăm)
              ngày kể từ ngày kể từ ngày có sự thay đổi.
            </li>
            <li>
              Các thông tin Bên B gửi cho Bên A để khai báo tài khoản bao gồm tối thiểu các thông
              tin như dưới đây, và có thể được Bên A yêu cầu bổ sung tùy từng trường hợp thẩm định
              theo yêu cầu của Đối tác cung cấp dịch vụ của Bên A:
            </li>
            <ol>
              &bull; Tên Đơn vị chấp nhận thanh toán. (Tên đầy đủ của ĐVCNTT hoặc Tên trên đăng ký
              kinh doanh đối với doanh nghiệp)
            </ol>
            <p>&nbsp;</p>
            <ol>
              &bull; Tên viết tắt: (là tên sẽ hiển thị trên màn hình thanh toán của khách hàng)
            </ol>
            <p>&nbsp;</p>
            <ol>
              &bull; Loại merchant: Doanh nghiệp/Cá nhân
            </ol>
            <p>&nbsp;</p>
            <ol>
              &bull; Loại hình ngành nghề kinh doanh
            </ol>
            <p>&nbsp;</p>
            <ol>
              &bull; Số đăng ký kinh doanh áp dụng trường hợp là Doanh nghiệp; mã số hộ đăng ký kinh
              doanh áp dụng trường hợp là Hộ kinh doanh; Số CMND/CCCD còn hiệu lực, áp dụng cho
              trường hợp là Cá Nhân.
            </ol>
            <p>&nbsp;</p>
            <ol>
              &bull; Ngày hết hạn của giấy đăng ký kinh doanh
            </ol>
            <p>&nbsp;</p>
            <ol>
              &bull; Hình ảnh giấy đăng ký kinh doanh/hộ kinh doanh và hình ảnh mặt trước, mặt sau
              CMTND/CCCD/Hộ Chiếu của người đại diện
              <b>(Lưu ý: CMTND/CCCD/Hộ chiếu yêu cầu còn hiệu lực trong vòng 6 tháng) </b>
            </ol>
            <p>&nbsp;</p>
            <ol>
              &bull; Tên người đại diện
            </ol>
            <p>&nbsp;</p>
            <ol>
              &bull; Số điện thoại và email liên hệ của ĐVCNTT
            </ol>
            <p>&nbsp;</p>
            <ol>
              &bull; Địa chỉ của ĐVCNTT
            </ol>
            <p>&nbsp;</p>
            <ol>
              &bull; Hình ảnh của các điểm chấp nhận thanh toán: (bao gồm ít nhất 3 ảnh): Hình ảnh
              biển hiệu bên ngoài (hiển thị địa chỉ thực tế và tên điểm chấp nhận thanh toán); Hình
              ảnh quầy trưng bày, quầy thanh toán; Hình ảnh địa điểm kinh doanh trên Google map
              <b
                >(Lưu ý: Các hình ảnh trên của điểm chấp nhận thanh toán cần có sự xuất hiện của
                POSM của các Kênh thanh toán QR Quốc tế & dung lượng ảnh không quá 2MB/ảnh)</b
              >
            </ol>
            <p>&nbsp;</p>
            <li>
              Chỉ có các giao dịch khách hàng đã thanh toán và được ghi nhận thành công trên hệ
              thống Bên A mới được tiến hành đối soát và thanh toán.
            </li>
            <li>
              Bên B không thu thêm bất kỳ một khoản phí nào, không tăng giá hàng hoá dịch vụ đối với
              các giao dịch thanh toán bằng QRCode do Bên A cung cấp so với các hình thức thanh toán
              khác và/hoặc các nhà cung cấp dịch vụ thanh toán bằng QRCode khác, đối tượng Khách
              hàng khác. Nếu Bên A, Khách hàng hoặc bất kỳ bên thứ ba nào có bằng chứng về việc làm
              này thì Bên A sẽ có quyền truy đòi Bên B khoản tiền thu thêm, đồng thời phạt vi phạm
              hợp đồng đối với Bên B một khoản bằng 8% giá trị nghĩa vụ bị vi phạm. Khoản tiền truy
              đòi và phạt vi phạm (nếu có) sẽ được yêu cầu thanh toán trực tiếp trong thời hạn 03
              (ba) ngày kể từ ngày có thông báo của Bên A hoặc khấu trừ trực tiếp vào khoản thanh
              toán của Bên B.
            </li>
            <li>
              Bên B chỉ được thực hiện việc chấp nhận thanh toán qua Phương thức thanh toán bằng
              QRCode của Bên A, không được phép cung cấp hoặc nhận thanh toán hộ cho một Bên khác;
            </li>
            <p>&nbsp;</p>
          </ul>
        </li>
        <li>
          <h1>PHÍ DỊCH VỤ</h1>
          <div class="table-responsive">
            <table>
              <thead>
                <tr class="bg-head">
                  <th style="width: 100px"><b>Số TT</b></th>
                  <th><b>Kênh thanh toán</b></th>
                  <th><b>Mức phí </b></th>
                  <th><b>Ghi Chú</b></th>
                </tr>
              </thead>
              <tbody>
                <tr class="txt-center">
                  <td class="txt-center">1</td>
                  <td>Phí đăng ký và duy trì</td>
                  <td>
                    <span>
                      <b>Miễn Phí</b>
                    </span>
                  </td>
                  <td></td>
                </tr>
                <tr class="txt-center">
                  <td class="txt-center">2</td>
                  <td>Bên B phải ký quỹ cho Bên A</td>
                  <td>
                    <span>
                      <b>Không</b>
                    </span>
                  </td>
                  <td></td>
                </tr>
                <tr class="txt-center">
                  <td class="txt-center">3</td>
                  <td>WeChat Pay</td>
                  <td>
                    <span>
                      <b>1.8%</b>
                    </span>
                  </td>
                  <td></td>
                </tr>
                <tr class="txt-center">
                  <td class="txt-center">4</td>
                  <td>GLN Hana Bank</td>
                  <td>
                    <span>
                      <b>1.8%</b>
                    </span>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <p><b>Lưu ý:</b> Đơn vị tính là VNĐ và đã bao gồm VAT</p>
          </div>
        </li>
        <li>
          <h1>QUY TRÌNH HOÀN HỦY GIAO DỊCH</h1>
          <ol>
            <li>
              <span>Hoàn trả giao dịch</span>
            </li>
            <ul>
              <li>
                Việc hoàn trả được thực hiện dựa trên giao dịch gốc và số tiền hoàn trả không được
                vượt quá tổng số tiền giao dịch gốc.
              </li>
              <li>
                Bên B có quyền yêu cầu Bên A thực hiện hoàn trả giao dịch cho khách hàng bằng cách
                gửi yêu cầu hoàn trả giao dịch qua email đầu mối tiếp nhận. Để thực hiện hoàn trả
                tiền cho khách hàng, Bên A sẽ tạm hoãn thanh toán số tiền của giao dịch hoàn trả
                hoặc khấu trừ số tiền Bên B cần trả lại vào khoản thanh toán tiếp theo hoặc yêu cầu
                Bên B chuyển khoản số tiền cần hoàn trả cho Bên A.
              </li>
              <li>
                Bên B không được phép ứng/hoàn/chuyển tiền cho khách hàng hoặc bên thứ ba dưới bất
                kỳ hình thức nào khác đối với các giao dịch đã được hệ thống Bên A ghi nhận thành
                công mà không thông qua hệ thống Bên A hoặc được sự đồng ý bằng văn bản (hoặc các
                hình thức khác được Bên A chấp nhận);
              </li>
            </ul>
            <li>
              <span>Bồi hoàn giao dịch</span>
            </li>
            <p>
              Bên A có quyền tạm hoãn, từ chối thanh toán hoặc thu hồi một phần, toàn bộ giao dịch
              đã thanh toán cho Bên B trong các trường hợp:
            </p>
            <p>&nbsp;</p>
            <ol>
              &bull; Giao dịch là gian lận, giả mạo hoặc bị chủ tài khoản/ví khiếu nại là gian lận,
              giả mạo hoặc giao dịch nghi ngờ là gian lận, giả mạo theo thông báo của đối tác bên A
            </ol>
            <p>&nbsp;</p>
            <ol>
              &bull; Giao dịch không được Bên A thông báo cho Bên B là thành công
            </ol>
            <p>&nbsp;</p>
            <ol>
              &bull; Giao dịch bị khiếu nại và Bên B không thể cung cấp đầy đủ và đúng hạn chứng từ
              để chứng minh giao dịch hoặc cung cấp chứng từ giả mạo. Bên B không tuân thủ việc cung
              cấp thông tin, dữ liệu cho Bên A theo đúng quy định của Hợp đồng.
            </ol>
            <p>&nbsp;</p>
            <ol>
              &bull; Việc cung cấp hàng hoá/dịch vụ giữa Bên B và khách hàng vi phạm pháp luật Việt
              Nam.
            </ol>
            <p>&nbsp;</p>
            <ol>
              &bull; Bên B không tuân thủ các điều khoản, điều kiện của Hợp đồng cũng như các quy
              định khác bằng văn bản của ngân hàng và/hoặc Bên A (nếu có)
            </ol>
          </ol>
        </li>
        <li>
          <h1>QUY ĐỊNH LIÊN QUAN ĐẾN CHỨNG TỪ GIAO DỊCH</h1>
          <ul>
            <li>
              Trong trường hợp nhận được yêu cầu cung cấp chứng từ của Bên A cho các giao dịch tra
              soát, khiếu nại, Bên B phải cung cấp đầy đủ chứng từ để chứng minh giao dịch là có
              thực và thực hiện theo đúng yêu cầu cung cấp hàng hóa, dịch vụ giữa Bên B và khách
              hàng trong vòng 3 ngày làm việc. Bên B phải chịu hoàn toàn trách nhiệm đối với các
              giao dịch này khi không thể cung cấp chứng từ, cung cấp chứng từ chậm trễ và/hoặc cung
              cấp chứng từ giả mạo.
            </li>
            <li>
              Chứng từ giao dịch là hóa đơn bản in toàn bộ các thông tin (không chấp nhận hóa đơn
              viết tay):
            </li>
          </ul>
          <p>&nbsp;</p>
          <ol>
            &bull; Thông tin Bên B: Tên đơn vị/cửa hàng (dấu đơn vị nếu có), Số điện thoại, Địa chỉ
            cửa hàng
          </ol>
          <p>&nbsp;</p>
          <ol>
            &bull; Thông tin khách hàng: Tên khách hàng, thông tin liên hệ của khách hàng
          </ol>
          <p>&nbsp;</p>
          <ol>
            &bull; Thông tin đơn hàng: Ngày giao dịch, Tên hàng hóa/dịch vụ cung cấp (mã hàng
            hóa/sản phẩm) theo từng khoản chi tiết, Số lượng, Đơn giá, Tổng Giá trị thanh toán
          </ol>
        </li>
        <li>
          <h1>DANH MỤC CÁC SẢN PHẨM DỊCH VỤ KHÔNG HỖ TRỢ</h1>
          <div class="table-responsive">
            <table>
              <thead>
                <tr class="bg-head">
                  <th style="width: 100px"><b>Số TT</b></th>
                  <th><b>Danh mục cấm</b></th>
                  <th><b>Loại sản phẩm</b></th>
                </tr>
              </thead>
              <tbody v-for="(item, i) in dataProductNoSupport" :key="i">
                <tr class="txt-center">
                  <td :rowspan="item.product.length + 1" class="txt-center">{{ i + 1 }}</td>
                  <td :rowspan="item.product.length + 1">{{ item.category }}</td>
                  <td>
                    <span>
                      {{ item.product[0] }}
                    </span>
                  </td>
                </tr>
                <tr
                  class="txt-center"
                  v-for="(product, index) in item.product.slice(1)"
                  :key="index"
                >
                  <td>
                    <span>{{ product }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </li>
        <li>
          <h1>ĐIỀU KHOẢN THI HÀNH</h1>
          <ol class="form-style2">
            <li>
              Phụ lục này là bộ phận không thể tách rời của Hợp đồng và các điều khoản khác của Hợp
              đồng vẫn được giữ nguyên. Các bên cam kết tuân thủ các quy định trong Phụ lục Hợp đồng
              này.
            </li>
            <li>
              Phụ lục này có hiệu lực kể từ ngày đại diện có thẩm quyền của hai Bên tham gia ký kết.
              Thời hạn hiệu lực của Phụ lục này được xác định theo thời hạn hiệu lực của Hợp đồng
              nêu trên trừ khi hai bên có thỏa thuận khác bằng văn bản.
            </li>
            <li>
              Phụ lục này được lập thành 02 (hai) bản có nội dung và giá trị pháp lý như nhau, mỗi
              Bên giữ 01 (một) bản.
            </li>
          </ol>
        </li>
      </ol>
      <Footer
        v-if="!checkCreatedDateNganluong(dataAppendix)"
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="true"
      ></Footer>
      <FooterNL
        v-else
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="true"
      ></FooterNL>
    </div>
  </div>
</template>

<script>
  import Header from '../block/header.vue'
  import Footer from '../block/footer.vue'
  import HeaderNL from '../block/headerNL.vue'
  import FooterNL from '../block/footerNL.vue'
  export default {
    props: ['dataContract', 'appendix'],
    components: {
      Header,
      Footer,
      HeaderNL,
      FooterNL,
    },
    data() {
      return {
        dataProductNoSupport: [
          {
            category: 'Sản phẩm văn hóa đồi trụy, mại dâm',
            product: [
              'Sản phẩm tình dục',
              'Các sản phẩm/ ấn phẩm nghe nhìn, Các kênh chương trình khiêu dâm, khiếm nhã và đồi trụy',
              'Dịch vụ khiêu dâm, khiếm nhã và đồi trụy',
            ],
          },
          {
            category: 'Bộ phận, cơ thể người',
            product: ['Buôn người', 'Bộ phận cơ thể người', 'Tro cốt'],
          },
          {
            category: 'Động, thực vật được bảo vệ',
            product: [
              'Động vật được quốc gia bảo vệ; Động vật hoang dã',
              'Tất cả các loại ngà, sừng tê giác và các sản phẩm từ ngà, sừng tê giác',
              'Sinh vật sống',
              'Các sản phẩm làm từ động vật',
              'Thực vật được quốc gia bảo vệ',
              'Thiết bị săn bắn động vật',
              'Bất kỳ động vật, thực vật hoặc sản phẩm có chứa vi trùng, sâu bệnh nguy hiểm',
            ],
          },
          {
            category: 'Thuốc cấm, các chất ma túy, chất gây nghiện',
            product: [
              'Chất gây nghiện, chất hướng thần Cần sa',
              'Ma túy',
              'Tiền chất hoặc công cụ gây nghiện',
              'Dụng cụ điều chế, đóng gói, thiết bị sử dụng thuốc cấm',
              'Các loại thuốc cấm khác',
            ],
          },
          {
            category: 'Thuốc lá và Rượu',
            product: [
              'Thuốc lá',
              'Các loại rượu',
              'Các sản phẩm liên quan đến thuốc lá và phụ kiện sử dụng',
            ],
          },
          {
            category: 'Cổ vật, kim loại quý hiếm, khoáng sản',
            product: ['Cổ vật, bảo vật Quốc gia', 'Kim loại quý chưa qua chế tác', 'Khoáng sản'],
          },
          {
            category: 'Các hóa chất nguy hiểm, gây cháy nổ, chất độc hạ',
            product: [
              'Chất phóng xạ',
              'Chất nổ, các loại hóa chất dễ gây cháy nổ',
              'Pháo hoa và các loại pháo bị hạn chế',
              'Thuốc trừ sâu, Thuốc bảo vệ thực vật',
              'Các hóa chất độc hại và độc dược',
              'Thuốc gây mê và thuốc an thần',
            ],
          },
          {
            category: 'Dược phẩm',
            product: ['Thuốc tây', 'Dược phẩm hỗ trợ tình dục', 'Các loại dược phẩm phi pháp khác'],
          },
          {
            category: 'Cá độ, đánh bạc, xổ số, chơi game',
            product: ['Đánh bạc và các dụng cụ đánh bạc, Các trò chơi quy đổi thành tiền mặt'],
          },
          {
            category:
              'Tài liệu phản động, khủng bố, xâm phạm chính trị, pháp luật, an ninh Quốc gia',
            product: [
              'Các sản phẩm nghe nhìn mang tính chính trị bất hợp pháp, Bí mật quốc gia, sản phẩm nội dung phản động',
            ],
          },
          {
            category: 'Quân sự, an ninh (Phù hiệu, cấp hiệu, thiết bị của Quân đội)',
            product: ['Trang thiết bị liên quan đến Quốc phòng an ninh, quân đội và công an'],
          },
          {
            category: 'Vũ khí, đạn dược',
            product: [
              'Vũ khí có sự kiểm soát, Súng, Pháo, Vũ khí tự vệ, Vũ khí quân dụng, Bom, mìn, lựu đạn, ngư lôi, thủy lôi, đạn, Thiết bị chống đạn, Thiết bị áp chế bằng âm thanh, Thiết bị khác',
            ],
          },
          {
            category: 'Giấy tờ giả',
            product: ['Giấy tờ tùy thân', 'Các loại giấy tờ pháp lý khác'],
          },
          {
            category: 'Vi phạm quyền riêng tư',
            product: [
              'Thông tin cá nhân vi phạm quyền riêng tư của người khác',
              'Vi phạm quyền cá nhân, dịch vụ truy xuất thông tin ',
            ],
          },
          {
            category: 'Dịch vụ bất hợp pháp, vi phạm an ninh mạng',
            product: [
              'Thiết bị xâm nhập bất hợp pháp, công cụ gián điệp, Thiết bị ngụy trang (máy ghi âm, máy ghi hình, định vị trừ smart phone và smart watch), Liên quan đến hacking, Phần mềm độc hại, Giấy tờ giả (Giấy tờ tùy thân và Các loại giấy tờ pháp lý khác), Phát hành giấy chứng nhận và đúc tạc nhãn hiệu, con dấu mà có sự vi phạm pháp luật, Lưu trữ đám mây',
            ],
          },
          {
            category: 'Tài chính, Tiền tệ',
            product: [
              'Bán hàng đa cấp',
              'Tiền giả, tiền tệ đang lưu hành',
              'Dịch vụ ngoại hối, Mua bán ngoại tệ',
              'Bán hoặc mua tài khoản ngân hàng hoặc thẻ ngân hàng trái với các điều luật áp dụng',
              'Các sản phẩm tài chính ngân hàng',
              'Các công cụ tài chính',
              'Tiền ảo và các giao dịch tiền tệ ảo khác',
              'Dịch vụ thanh toán bằng thẻ tín dụng',
              'Vật liệu và thiết bị được sử dụng để sản xuất Sản Phẩm Tài Chính',
              'Mua bán thẻ ngân hàng',
            ],
          },
        ],
      }
    },
    computed: {
      customerInfo() {
        return this.dataContract.customerInfoRes ?? this.dataContract.customerInfoCommon ?? {}
      },
      dataAppendix() {
        return this.appendix
      },
    },
  }
</script>

<style scoped src="@/assets/css/style-review.css"></style>
